/**
 * A traveller who chose a plan before registering goes from registration
 * straight to checkout, so first run (/traveler/welcome) has not happened
 * yet. This flag sends the payment-success page there instead of to Home.
 */

const KEY = "healthpass.firstRunAfterPayment";

export function markFirstRunAfterPayment(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    // Without storage the traveller lands on Home and finds first run later.
  }
}

/** Whether first run is still owed; clears the flag as it is read. */
export function takeFirstRunAfterPayment(): boolean {
  try {
    const owed = localStorage.getItem(KEY) === "1";
    localStorage.removeItem(KEY);
    return owed;
  } catch {
    return false;
  }
}
